<template>
  <div class="h-100">
    <div class="columns is-flex-wrap h-100 is-marginless	">
      <div class="column is-4 bgcolor is-paddingless" >
        <div :class="{bgcolorcompany : this.$route.name == 'signupprofile',bgcolormentor:this.$route.name != 'signupprofile'}">
        </div>
      </div>
      <div class="column is-8">
        <div class="columns">
          <div class="column is-10 mg-x-auto">
            <div class="marginmobile signup">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {HTTP,HTTPMentor} from "@/axios.js";
import navbarbg from './navbarbg'
// import navbar from './navbar'
export default {
  mounted(){
    // console.log()
  },
        data() {
            return {
                signup:{
                  name:'',
                  surname:'',
                  email:'',
                  password:'',
                  userLevel:50,
                  profilePic:'',
                },
                  repassword:'',
                  tems:null,
                  file:{
                    name:''
                  },
                  url:null,
            }
        },
        components:{
          navbarbg
        },
}
</script>
<style scoped>
/* preview */
.blue{
  color:rgb(13, 106, 202);
}
label{
    cursor: pointer;
}
#preview{
    display: flex; justify-content: center;
}
#preview .haveimg{
    border-radius:50%;
}
#preview .noimg{
    position:relative;
}
#preview .noimg .font{
    position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)
}
#preview .noimg .circle{
    border-radius: 50%; height: 170px !important; width: 170px !important; background: rgba(0,0,0,0.25); margin: 0 auto;
}
/* preview */
.bgcolorcompany{
  /* background-color: ; */
  background:#FFA800 url("../../assets/Intersect_bg.png");
  overflow:hidden !important;border-color:white !important;
  /* background-image: ; */
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.bgcolormentor{
  /* background-color: ; */
  background:#0d6aca url("../../assets/Intersect_bg.png");
  overflow:hidden !important;border-color:white !important;
  /* background-image: ; */
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.tems{
  position: relative; 
  bottom: 3px;
  color:rgb(165,229,251);line-height: 1.25;
}
.fontnormal{
  font-family: 'Raleway';
  font-size: 14px;
  color: white;
}
.fontbold2{
  font-size: 25px;
  color: black;
  font-weight: bold;
}
.container{
  background:white;
  text-align: initial;
}
#fullheight{
  margin: 0;
  height: 100vh;
  overflow: hidden;
}
.backgroundleft{
  background-image: linear-gradient(#0d6aca, #0fb7f3);
  margin: 0;
}
.buttonc{
  padding-left: 2rem;
  padding-right: 2rem;
  width: 100%;
  background-image: linear-gradient(rgb(14,129,214), rgb(15,166,234));
  border-radius: 40px;
}
   .columntwo{
    float:left;width:70%
    }

  .changesignin{
    margin-top: 4vw;
    text-align: center;
    margin-bottom:10px
  }



/* mobile */
.menutop_mobile .fontbold2{
    display: none
}
.circlehamburger{
    display: none;
    height: 50px;
    width: 50px;
    position: fixed;
    background: #0d6aca;
    color: white;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    top: 5px;
    right: 5px;
    transition: all 0.5s;
    z-index: 100;
}
.widthmenu{
width:90%;float:right;
}

.column.is-four-fifths{
        margin-top: 10px;
    }
div.control{
  width: 100%;
}
.customcolumns{
  margin-left: 25%;
}
@media screen and (min-width: 1472px){
.container {
    max-width: 1150px;
    width: 1150px;
}
}

@media only screen and (max-width: 951px) {
  .customcolumns{
    margin-left: 0;
  }
  .columns{
    display: block;
}
    .column.is-four-fifths{
        margin-top: 75px;
    padding: 22px;
    }
    div.column.is-one-quarter.box-step.pd-5.bgcolor{
    min-height: 200px;
    min-width: 390px;
    position: absolute;
    right: 2px;
    z-index: 88;
    border-radius: 20px;
    transform: scaleX(0);
      top: -300px;
    transition: all 0.5s;
    opacity: 0;
}
       .menutop_mobile .fontbold2{
    display: block
	}
 .circlehamburger{
    display: flex;
}
.menutop_mobile{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 4rem;
    background: #0d6aca;
    z-index: 99;
    transition: all 0.5s;
}

.openprofile{
    top: 70px !important;
    opacity: 1 !important;
    transform: scaleX(1)!important;
}
}

@media only screen and (max-width: 463px) {
.column{
  padding: 2.5px 0 0 0 ;
}
}
@media only screen and (max-width: 410px) {
  .columntwo{
    width:calc(100% - 130px)
  }
} 
@media only screen and (max-width: 400px) {
    div.column.is-one-quarter.box-step.pd-5.bgcolor{
       width: 355px;
           min-width: 366px;
    }
    .widthmenu{
    width: 100%;
    }
}
</style>

